// extracted by mini-css-extract-plugin
export default {"fullScreenButton":"AnalyticsPage_fullScreenButton__DfJ07"};